import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const FraudSettingRBAC = {
  pageID: 'f4ddf1c4d84c52bfa24c9acea897dc6f',
  elementID: {
    View: 'cc589ce3a90b9713d308181029efcc08',
    CreateFraudSetting: 'a9ea07876361e2f61abf277efb43abdd',
    UpdateFraudSetting: '714903d59d7bc28d5fe4731180748b56',
    ToggleStatus: '6eb00f265db5611356db2c66252a7ddf',
    SettingFilterWatchtower: '6a99adf74a5c1f0c76f26dac9052f2cf',
  },
} as const

export const useFraudSettingRBACPage = createUseRBAC(FraudSettingRBAC.elementID)

export type UseFraudSettingRBACPageType = ReturnType<typeof useFraudSettingRBACPage>
